import React from 'react'

export default function DizeeModal({ isOverlayVisible, setOverlayVisible, children }) {
    const token = localStorage.getItem('dizeeToken');
    const handleOverlayClick = (e) => {
        if (e.target.id === 'overlay') {
            setOverlayVisible(false);
        }
    };

    return (
        <div
            id="overlay"
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex justify-center items-center z-50"
            onClick={handleOverlayClick}
        >
            <div className="w-full max-w-[350px] mx-4 transform overflow-hidden rounded-2xl bg-black border-2 border-[#FF2300] p-6 text-left align-middle shadow-xl transition-all">
                {children}
            </div>
        </div>
    )
}
